'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
function CopyToClipboard(value) {
  return e => {
    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    const target = e.currentTarget.querySelector('span') || e.currentTarget;
    const text = target.innerHTML;
    target.innerHTML = 'Copied!';
    setTimeout(() => {
      target.innerHTML = text;
    }, 1500);
  };
}
exports.default = CopyToClipboard;
